import { render, staticRenderFns } from "./list-item-title.vue?vue&type=template&id=427540e7&scoped=true"
import script from "./list-item-title.vue?vue&type=script&lang=ts&setup=true"
export * from "./list-item-title.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./list-item-title.vue?vue&type=style&index=0&id=427540e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427540e7",
  null
  
)

export default component.exports